import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Form, TextArea, Typography } from '@/components';
import { nullableStringSetter } from '@/helpers';
import { OpportunityDetails } from '../../../types';

export type AboutSellerFormProps = {
  readonly id: string;
  readonly opportunity: OpportunityDetails;
  readonly onSubmit: (data: any) => void;
};

export function AboutSellerFormNew({ id, opportunity, onSubmit }: AboutSellerFormProps) {
  const { t } = useTranslation(['opportunities']);

  const options = useMemo(
    () => ({
      defaultValues: {
        about_you: opportunity.aboutYou,
      },
    }),
    [opportunity]
  );

  return (
    <Form
      id={id}
      onSubmit={(data) => {
        onSubmit({
          about_you: data.about_you,
        });
      }}
      options={options}
    >
      {({ formState, register, watch }) => (
        <div className="space-y-4">
          <Typography as="p" color="secondary" size="body-3" weight="normal" className="mt-1 italic">
            {t(
              'Please, fill in this section with an anonymous summary of your relevant experience in the development, operation, and management of similar assets. Provide details on you expertise and track record in the renewable energy sector.'
            )}
          </Typography>
          <Typography as="p" size="body-2" weight="semibold" relaxed>
            {t('About the seller')}
          </Typography>
          <Field id="about_you" label={t('')} delay={0.3}>
            <TextArea
              id="about_you"
              color="primary"
              placeholder="Type here..."
              registration={register('about_you', { setValueAs: nullableStringSetter })}
            />
          </Field>
        </div>
      )}
    </Form>
  );
}
